<h1 mat-dialog-title>
    {{ data.isEdit ? 'Editar Proveedor' : 'Nuevo Proveedor' }}
  </h1>
  
  <div mat-dialog-content>
    <form [formGroup]="mainForm" (ngSubmit)="submitForm(mainForm.value)">
      <app-form-component 
        [fieldsConfig]="formFields"
        [formGroup]="mainForm"
        [submitButtonText]="data.isEdit ? 'Actualizar' : 'Guardar'"
        [resetButtonText]="'Cancelar'"
        [showBotons]="false"
        [formLayout]="'vertical'"
        [canEdit]="true"
        (formSubmit)="submitForm($event)">
      </app-form-component>
  
      <div mat-dialog-actions align="end">
        <button mat-button type="button" (click)="onCancel()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="mainForm.invalid">
          {{ data.isEdit ? 'Actualizar' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>